import { useCallback } from 'react';
import { useOpenDrawer } from '../../../../state/Drawer/actions/useOpenDrawer';
import { useWorkflowForm } from '../../../../contexts/CampaignWorkflowFormContext';
import { DrawerType } from '../../../../state/Drawer/DrawerState';

const useOpenDrawerSettings = () => {
  const openDrawer = useOpenDrawer();
  const { actions } = useWorkflowForm();

  const openDrawerSettings = useCallback(
    (drawId?: string, type?: DrawerType) => {
      openDrawer(drawId, type);
      actions.setFocused(drawId, true);
    },
    [openDrawer, actions],
  );

  return { openDrawerSettings };
};

export default useOpenDrawerSettings;
